package api.data

import dev.gitlive.firebase.firestore.DocumentSnapshot
import dev.gitlive.firebase.firestore.Timestamp
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class DataPropertyOwner(
    @SerialName("id")
    var id: String? = null,

    @SerialName("propertyTitle")
    var propertyTitle: String? = null,

    @SerialName("email")
    var email: String? = null,

    @SerialName("location")
    var location: String? = null,

    @SerialName("firstName")
    var firstName: String? = null,

    @SerialName("lastName")
    var lastName: String? = null,

    @SerialName("phone")
    var phone: String? = null,

    @SerialName("timestamp")
    var timestamp: Timestamp? = null
)


fun DocumentSnapshot.toDataPropertyOwner(): DataPropertyOwner{
    return DataPropertyOwner(
        id = get("id"),
        propertyTitle = get("propertyTitle"),
        email = get("email"),
        location = get("location"),
        firstName = get("firstName"),
        lastName = get("lastName"),
        phone = get("phone"),
        timestamp = get("timestamp")
    )
}